module.exports = __webpack_public_path__ + "images/emoji/white_medium_square.5e7fc5d2174e31d37702.png";